import FloatingActionButton from "./FloatingActionButton";

export default FloatingActionButton;
